export default __webpack_public_path__ + "static/tablet_sek2_KV03-603296bf7c43ce7cbc977597e3781277.mp4";